import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import { useEffect, useState } from "react";
import { 
  NumberFormatValues, 
  NumericFormat, 
  SourceInfo 
} from "react-number-format";

const Container = styled(FormControl)(() => ({
  maxWidth: '100%',
  minWidth: '33%'
}));

type CompanyProfileNumEmployeesInputProps = {
  className?: string;
  numEmployees?: string | number;
  onChange: (numEmployees: string) => void;
};

export default function CompanyProfileNumEmployeesInput(props: Readonly<CompanyProfileNumEmployeesInputProps>) {
  const { className, onChange } = props;

  const [numEmployees, setNumEmployees] = useState<string | number>(props.numEmployees ?? "");

  useEffect(() => {
    setNumEmployees(props.numEmployees ?? "");
  }, [props.numEmployees]);

  function hasInvalidNumEmployees(): boolean {
    return Boolean(
      numEmployees 
      && numEmployees.toString().length > 0 
      && (
        Number.isNaN(Number(numEmployees)) 
        || Number(numEmployees) < 0
      )
    );
  }

  return (
    <Container className={className}>
      <NumericFormat
        id="numEmployees"
        variant="outlined"
        customInput={TextField}
        label="Number of Employees"
        value={numEmployees}
        type='text'
        thousandSeparator
        error={hasInvalidNumEmployees()}
        helperText={hasInvalidNumEmployees() ? "Invalid number of employees" : ""}
        onValueChange={(values: NumberFormatValues, _sourceInfo: SourceInfo) => {
          setNumEmployees(values.value);
          onChange(values.value);
        }}
      />
    </Container>
  );
}
